import { RidangoReduxAction } from '@ridango/core';

import { ChangePasswordActions } from './change-password.actions';

export interface ChangePasswordState {
    loading: boolean;
    done: boolean;
    error: any;
    isSubmitted: boolean;
}

export const CHANGE_PASSWORD_INITIAL_STATE: ChangePasswordState = {
    loading: false,
    done: false,
    error: null,
    isSubmitted: false,
};

export function changePasswordReducer(
    state: ChangePasswordState = CHANGE_PASSWORD_INITIAL_STATE,
    action: RidangoReduxAction
): ChangePasswordState {
    switch (action.type) {
        case ChangePasswordActions.GET_NEW_PASSWORD:
            return {
                ...state,
                isSubmitted: false,
            };
        case ChangePasswordActions.SET_NEW_PASSWORD:
            return {
                ...state,
                loading: true,
                isSubmitted: false,
            };
        case ChangePasswordActions.SET_NEW_PASSWORD_SUCCESS:
            return {
                ...state,
                done: true,
                isSubmitted: true,
                error: null,
            };
        case ChangePasswordActions.SET_NEW_PASSWORD_FAILED:
            return {
                ...state,
                loading: false,
                error: action.payload,
                isSubmitted: true,
            };
    }

    return state;
}
